import React from 'react';
import { Tabs } from '@mantine/core';
import styles from './CustomTabs.module.css';

interface CustomTabsProps {
  categories: Record<string, string>;
  labels: Record<string, string>;
  renderPanel: (category: string) => React.ReactNode;
  variant?: 'primary' | 'secondary';
}

const CustomTabs: React.FC<CustomTabsProps> = ({
  categories,
  labels,
  renderPanel,
  variant = 'primary',
}) => {
  return (
    <Tabs defaultValue={Object.values(categories)[0]}>
      <Tabs.List
        className={`${styles.tabsList} ${variant === 'secondary' ? styles.secondaryTabsList : ''}`}
      >
        {Object.values(categories).map((category) => (
          <Tabs.Tab
            key={category}
            value={category}
            className={`${styles.tab} ${variant === 'secondary' ? styles.secondaryTab : ''}`}
          >
            {labels[category]}
          </Tabs.Tab>
        ))}
      </Tabs.List>

      {Object.values(categories).map((category) => (
        <Tabs.Panel key={category} value={category} pt="lg">
          {renderPanel(category)}
        </Tabs.Panel>
      ))}
    </Tabs>
  );
};

export default CustomTabs;
